/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */

export const fdc3Version = "2.1.0";
